import { render, staticRenderFns } from "./PreviewButton.vue?vue&type=template&id=2e5d854c&scoped=true&"
import script from "./PreviewButton.vue?vue&type=script&lang=js&"
export * from "./PreviewButton.vue?vue&type=script&lang=js&"
import style0 from "./PreviewButton.vue?vue&type=style&index=0&id=2e5d854c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d854c",
  null
  
)

export default component.exports